import React from "react";
import InputMask from "react-input-mask";
import {
  DocButton,
  FormField,
  FormInput,
  FormRow,
  FormRow2,
  RemoveButton,
  SearchCPFBar,
  SearchCPFContainer,
  SearchIcon,
} from "../styles/ChoosePlan";
import { getContractAssociatedInfo } from "../data/services/crew_service";
import LimitedRelationshipModel from "../data/models/limitedRelationship";

interface DependentProps {
  index: number;
  dependent: {
    nome: string;
    telefone: string;
    cpf: string;
    email: string;
    relationship: string;

    // ⬇️ ADICIONADO PARA DOCUMENTOS
    documentoFrente?: File | null;
    documentoVerso?: File | null;
  };
  onRemove: (index: number) => void;

  // ⬇️ PFform recebe TUDO que mudar no dependente
  onChange: (index: number, field: string, value: any) => void;

  relationships: LimitedRelationshipModel[];
}

const Dependent: React.FC<DependentProps> = ({
  index,
  dependent,
  onRemove,
  onChange,
  relationships,
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    onChange(index, name, value);
  };

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    onChange(index, name, value);
  };

  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    tipo: "frente" | "verso"
  ) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];

      if (tipo === "frente") {
        onChange(index, "documentoFrente", file);
      } else {
        onChange(index, "documentoVerso", file);
      }
    }
  };

  const handleSearchClick = async () => {
    const cpf = dependent.cpf;

    if (!cpf || cpf.length !== 11) {
      alert("Por favor, insira um CPF válido com 11 dígitos.");
      return;
    }

    try {
      const { contract } = await getContractAssociatedInfo(cpf);

      if (contract) {
        onChange(index, "nome", contract.nome || "");
        onChange(index, "telefone", contract.telefoneEmp || "");
        onChange(index, "email", contract.emailCob || "");
      } else {
        alert("Nenhum contrato associado encontrado para o CPF informado.");
      }
    } catch (error) {
      console.error("Erro ao buscar informações do contrato:", error);
      alert("Erro ao buscar informações do contrato.");
    }
  };

  return (
    <>
      <FormField>
        <FormRow2>
          <h1>Dependente {index + 1}</h1>
          <RemoveButton onClick={() => onRemove(index)}>x</RemoveButton>
        </FormRow2>

        <SearchCPFContainer>
          <InputMask
            mask="99999999999"
            value={dependent.cpf}
            onChange={handleInputChange}
          >
            {(inputProps: any) => (
              <SearchCPFBar
                {...inputProps}
                name="cpf"
                placeholder="CPF (SOMENTE NÚMEROS)"
              />
            )}
          </InputMask>

          <SearchIcon size={20} onClick={handleSearchClick} />
        </SearchCPFContainer>
      </FormField>

      <FormRow>
        <FormField>
          <InputMask
            mask="(99) 99999-9999"
            value={dependent.telefone}
            onChange={handleInputChange}
          >
            {(inputProps: any) => (
              <FormInput
                {...inputProps}
                type="tel"
                name="telefone"
                placeholder="Telefone"
              />
            )}
          </InputMask>
        </FormField>

        <FormField>
          <select
            name="relationship"
            value={dependent.relationship}
            onChange={handleSelectChange}
          >
            <option value="" disabled>
              Grau de Parentesco
            </option>
            {relationships.map((item) => (
              <option
                key={item.id_parentesco ?? ""}
                value={item.id_parentesco ?? ""}
              >
                {item.parentesco}
              </option>
            ))}
          </select>
        </FormField>
      </FormRow>

      <FormRow>
        <FormField>
          <FormInput
            type="text"
            name="nome"
            placeholder="Nome Completo:"
            value={dependent.nome}
            onChange={handleInputChange}
          />
        </FormField>

        <FormField>
          <FormInput
            type="email"
            name="email"
            placeholder="E-mail:"
            value={dependent.email}
            onChange={handleInputChange}
          />
        </FormField>
      </FormRow>

      <FormField>
        <DocButton
          type="button"
          onClick={() =>
            document.getElementById(`uploadFrenteDep-${index}`)?.click()
          }
        >
          Faça upload de um documento original com foto (RG, CNH) - Frente
        </DocButton>
        <input
          id={`uploadFrenteDep-${index}`}
          type="file"
          accept="image/*,application/pdf"
          style={{ display: "none" }}
          onChange={(e) => handleFileChange(e, "frente")}
        />
        {dependent.documentoFrente && (
          <p>Arquivo: {dependent.documentoFrente.name}</p>
        )}
      </FormField>

      <FormField>
        <DocButton
          type="button"
          onClick={() =>
            document.getElementById(`uploadVersoDep-${index}`)?.click()
          }
        >
          Faça upload de um documento original com foto (RG, CNH) - Verso
        </DocButton>
        <input
          id={`uploadVersoDep-${index}`}
          type="file"
          accept="image/*,application/pdf"
          style={{ display: "none" }}
          onChange={(e) => handleFileChange(e, "verso")}
        />
        {dependent.documentoVerso && (
          <p>Arquivo: {dependent.documentoVerso.name}</p>
        )}
      </FormField>
    </>
  );
};

export default Dependent;
